import { Tab } from 'entities/Tab/interfaces';
import { SET_TABS, SET_TAB, DELETE_TAB } from './constants';
import { Actions } from './actions';

const initialState = {
  tabs: [] as Tab[],
};

export const tabsReducer = (state = initialState, action: Actions) => {
  switch (action.type) {
    case SET_TABS: {
      return {
        tabs: action.payload,
      };
    }
    case SET_TAB: {
      if (state.tabs.some((tab) => tab.id === action.payload.id)) {
        return state;
      }
      const type = (action.payload.id || '').split('_')[0] || '';
      const cleanTabs = state.tabs.filter((tab) => !tab.id.includes(`${type}_`));
      return {
        tabs: [...cleanTabs, action.payload],
      };
    }
    case DELETE_TAB: {
      return {
        tabs: state.tabs.filter((tab) => tab.id !== action.payload),
      };
    }
    default: {
      return state;
    }
  }
};
